import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormGroup, FormBuilder, Validators, ReactiveFormsModule} from '@angular/forms';
import {Labels} from 'src/app/constants/labels';
import {isBlank,isData,MustMatch,check_palindrome,isConsecutiveOK, validateWithUsername,isPresent} from 'src/app/utils/utils';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {AuthService} from 'src/app/services/auth-service/auth.service';
import {Router, ActivatedRoute} from '@angular/router';
import {RoutePath} from 'src/app/constants/routerPath';
import {ToastrService} from 'ngx-toastr';
import {KEYS} from 'src/app/constants/keys';
import {CommonService} from 'src/app/services/common-service/common.service';
import { CommonModule } from '@angular/common';
@Component({selector: 'app-forgot-password',
     imports:[CommonModule,ReactiveFormsModule],
     templateUrl: './forgot-password.component.html', 
     styleUrls: ['./forgot-password.component.scss']})
export class ForgotPasswordComponent implements OnInit {
      @ViewChild('appAutoFocus') appAutoFocus!: ElementRef;
    labelName = Labels.forgotPassword;
    labelButtons = Labels.buttons;
    labelMessages = Labels.messages;
    routePath = RoutePath;
    forgotPasswordForm! : FormGroup;
    submitted : boolean = false;
    userName : any = '';
    token : any = '';
    hidePsw : boolean = true;
    validateMsg : string = '';
    selectedPattern = "^(?=.*[A-Za-z])(?=.*\\d).+$";
    // selectedPattern : any = "^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d@$!%*#?&]{8,}$";
    // "^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d]{8,}$";
    fName : string = '';
    // "^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$";
    // Minimum six characters, at least one letter and one number:
    patternNormal : any = "^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d@$!%*#?&]{8,}$";

    // Minimum eight characters, at least one letter, one number and one special character:
    patternMedium : any = "^(?=.*[A-Za-z])(?=.*\\d)(?=.*[@$!%*#?&])[A-Za-z\\d@$!%*#?&]{8,}$";
    mustMatch : boolean = true;
    palindrome : boolean = true;
    messageLabel = Labels.messages;
    isConsecutiveOK : boolean = true;
    containsUserName : boolean = true;
    minLength : boolean = true;
    patternMissmatch : boolean = true;

    captchaStatus : any = null;
    captchaConfig : any = {
        type: 0,
        length: 6,
        cssClass: 'custom',
        back: {
            stroke: "#2F9688",
            solid: "#f2efd2"
        },
        font: {
            color: "#000000",
            size: "35px"
        }
    };

    constructor(private formBuilder : FormBuilder, private router : Router, private toastr : ToastrService, private route : ActivatedRoute, private commonService : CommonService, private authService : AuthService) {}
 ngAfterViewInit() {
    setTimeout(() => {
      this.appAutoFocus.nativeElement.focus();
    }, 1000);

  }
    ngOnInit(): void {
        this.InitilaizePageForm();

    }
    // ngDoCheck()
    // {
    // console.log('gotttttttttttttt')
    // }

    InitilaizePageForm() {
        let mailId = this.route.snapshot.queryParamMap.get("username");
        let name = mailId!.split('@');
        this.fName = '';
        if (name.length > 0) {
            this.fName = name[0];
        }
        this.forgotPasswordForm = this.formBuilder.group({
            newpassword: [
                '',
                [
                    Validators.required, Validators.minLength(8), Validators.pattern(this.selectedPattern)
                ]
            ],
            confirmpassword: ['', Validators.required]
        }, {
            validator: [
                MustMatch('newpassword', 'confirmpassword'),
                check_palindrome('newpassword'),
                isConsecutiveOK('newpassword'),
                validateWithUsername('newpassword', this.fName)
            ]
        })
    }

    ValidateNewPass(password : string) {
        if (!password) {
            this.resetvalidator();
            return;
        } else {
            const control = this.forgotPasswordForm.controls['newpassword'];
            control.setValue(password)
            const errors = control.errors || {}
            this.minLength = !! errors['minlength'];
            this.patternMissmatch = !! errors['pattern'];
            this.palindrome = !! errors['palindrome'];
            this.isConsecutiveOK = !! errors['isConsecutiveOK'];
            this.containsUserName = !! errors['containsUserName'];
            this.confirmPassword();
        }
    }
    confirmPassword() {
      const newPassword = this.forgotPasswordForm.get('newpassword') ?. value || "";
      const confirmPassword = this.forgotPasswordForm.get('confirmpassword') ?. value || "";
      this.mustMatch = newPassword !== confirmPassword;
  }
    onSubmit() {
        this.submitted = true;
        this.mustMatch = false;
        this.palindrome = false;
        this.isConsecutiveOK = false;
        this.containsUserName = false;
        this.minLength = false;
        this.patternMissmatch = false;
        if (!isPresent(this.forgotPasswordForm.controls['confirmpassword'].errors)) {
            this.forgotPasswordForm.controls['confirmpassword'].setErrors(null);
        }
        if (this.forgotPasswordForm.invalid) {
            if (this.forgotPasswordForm.controls['newpassword'].status != "VALID") {
                const errors = this.forgotPasswordForm.controls['newpassword'].errors;
                if (isPresent(errors!['minlength'])) {
                    this.minLength = true;
                }
                if (isPresent(errors!['pattern'])) {
                    this.patternMissmatch = true;
                }
            }
            if (this.forgotPasswordForm.controls['confirmpassword'].status != "VALID") {
                const errors = this.forgotPasswordForm.controls['confirmpassword'].errors;
                if (isPresent(errors!['palindrome'])) {
                    this.palindrome = true;
                }
                if (isPresent(errors!['isConsecutiveOK'])) {
                    this.isConsecutiveOK = true;
                }
                if (isPresent(errors!['containsUserName'])) {
                    this.containsUserName = true;
                }
                if (isPresent(errors!['mustMatch'])) {
                    this.mustMatch = true;
                }
            }

            return;
        }
        this.userName = this.route.snapshot.queryParamMap.get("username");
        this.token = this.route.snapshot.queryParamMap.get("token");
        this.commonService.ogLog("User Name:", this.userName);
        let token = this.commonService.SetPasswordUsingToken(this.userName, this.forgotPasswordForm.value.confirmpassword, this.token).subscribe((response) => {
            if (response != null) {
                if (response['error'] != '' && response['error'] != null) {
                    //this.toastr.error(response['error']);
                    this.commonService.showModalValidate(response['error'],'',this.messageLabel.static_messages.error,response['error']);
                } else if (response['message'] != '' && response['message'] != null) {
                    //this.toastr.success(response['message']);
                    this.commonService.showModalValidate(response['message'],'',this.messageLabel.static_messages.info,response['message']);
                    setTimeout(() => {
                        this.authService.redirectToLogin();
                    }, 2000);
                }
                if (response['warning'] != '' && response['warning'] != null) {
                    this.commonService.ogLog("Warning:", response['warning']);
                }
            } else {
                (error: any) => {
                    console.log('Password resetting error:', error);
                }
            }
        });
    }
    get f() {
        return this.forgotPasswordForm.controls;
    }

    resetvalidator() {
        this.minLength = true;
        this.patternMissmatch = true;
        this.palindrome = true;
        this.isConsecutiveOK = true;
        this.containsUserName = true;
        this.mustMatch = true;
    }

    onChangePswType() {
        this.hidePsw = !this.hidePsw;
    }

}
